import homepage from './homepage'
import personalHomepage from './personalHomepage'
import myClass from './myclass'
const student = {
  path: 'student',
  component: resolve => require(['../../../../components/pages/student_user/student'], resolve),
  redirect: 'student/homepage',
  children: [
    homepage,
    personalHomepage,
    myClass
  ]
}

export default student



// WEBPACK FOOTER //
// ./src/router/pages/student_user/student/index.js